import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Label,
  Input,
  FormFeedback,
  Col,
  Row,
} from "reactstrap";

// Import additional Libraries
import * as Yup from "yup";
import { useFormik } from "formik";

// Custom Axios
import axiosInstance from '../../utils/axiosInstance';

// Redux
import { useSelector, useDispatch } from "react-redux";


const PurchaseModal = ({ offer, offerImage, purchaseModal, toggle }) => {

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user);
  //console.log('userData:', userData);

  const [htmlContent, setHtmlContent] = useState('');
  const [purchaseLoading, setPurchaseLoading] = useState(false);

  const [purchasingEmail, setPurchasingEmail] = useState('');
  useEffect(()=>{
    if(userData.email){
      setPurchasingEmail(userData.email);
    }
  },[userData.email])


  const [buyVolume, setBuyVolume] = useState(1);
  useEffect(()=>{
    setBuyVolume(1);
  },[purchaseModal])


  const sendPurchase = async() => {
    const purchaseData = { offer, buyVolume };

    const emailPurchase = purchasingEmail;

    if(!emailPurchase){ return; }

    try {
      setPurchaseLoading(true);
      const response = await axiosInstance.post(`/api/payment/purchase-point/${emailPurchase}`,
        {purchaseData}
      );

      setHtmlContent(response.data); // Set the HTML content in the state

      // Trigger the script manually
      setTimeout(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = "document.getElementById('_form_aiochk').submit();";
        document.body.appendChild(script);
      }, 100);

      setPurchaseLoading(false);

    } catch (error) {
      console.error('Error:', error);
      setPurchaseLoading(false);
    }

  }


  


  return (
    <React.Fragment>


      {/* 專案編輯視窗 */}
      <Modal isOpen={purchaseModal}>

        {/* 專案編輯視窗標題 */}
        <ModalHeader 
          style={{ borderBottom: '1px solid #f0f2f6' }}
          toggle={()=>{toggle()}} 
          tag="h4"
        >購買點數</ModalHeader>

        {/* 專案編輯視窗內容 */}
        <ModalBody>

          <Form
            onSubmit={(e) => {
              e.preventDefault();
              return false;
            }}
          >
            <Row>
              <Col xs={12} style={{ padding: '0px 30px' }}>

                {/*
                <div className="mb-3">
                  <h5 className="form-label"
                    style={{ fontSize: '1rem' }}
                  >點數單位：{offer?.offerUnit}</h5>
                </div>

                <div style={{ display:"flex", justifyContent:"center", margin:"1rem 0rem" }}>
                  <img 
                    src={offerImage} 
                    alt="offerImage" 
                    style={{ 
                        width: '100px', 
                        height: '100px',
                        borderRadius: '50%',
                        objectFit: 'cover'
                    }}
                  />
                </div>
                */}

                {/* 資料庫客戶 */}
                <div className="mb-3">
                  <div className="mt-4">
                    <h3 style={{ fontSize: '17px', fontWeight: '400' }}>
                      選擇點數數量：
                    </h3>
                    <p className="card-title-desc">
                      {buyVolume*offer?.offerUnit || 0} 點
                    </p>
                    <input type="range" className="form-range" min={offer?.minVolume || 1} max={offer?.maxVolume || 10} id="customRange2" 
                      onChange={(e)=>{setBuyVolume(e.target.value)}}
                      defaultValue="1"
                    />
                  </div>
                </div>

                {/* 資料庫圖片 */}
                <div className="mb-3">
                  <h5 
                    className="font-size-14"
                    style={{ 
                      margin:'2vh 0vh 2vh 0vh',
                      fontSize: '17px',
                      fontWeight: '600'
                    }}
                  >
                    {`<相當於>`}
                  </h5>
                  <p style={{ margin:'1vh 0vh 1vh 0vh'}}>{buyVolume*offer?.offerUnit / 50} 份合約</p>
                </div>


                {/* Add an Email Input here */}
                <div className="mb-3">
                  <Label for="email" style={{ fontSize: '17px', fontWeight: '400' }}>
                    購買帳號
                  </Label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="輸入購買帳號信箱"
                    value={purchasingEmail}
                    onChange={(e) => setPurchasingEmail(e.target.value)}
                    required
                  />
                </div>


              </Col>
            </Row>

            {/* Save Button */}
            <Row>
              <Col className="single-pricing-card" style={{ border: 'none', marginBottom: '0px' }}>
                <div className="text-end">
                  <button className="demo text-decoration-none"
                    style={{ backgroundColor: 'white' }}
                    onClick={()=>{ sendPurchase(); }}
                  >
                    <i className="ri-arrow-right-line"></i>
                    取得點數
                  </button>
                </div>
              </Col>
            </Row>

          </Form>

          <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>


        </ModalBody>

      {/* ^專案編輯視窗 */}
      </Modal>
    </React.Fragment>
  );

};

export default PurchaseModal;



